import { FC } from "react";

const EditCustomRule: FC = () => {
  return (
    null
  )
}

export default EditCustomRule;
